export enum RoleOptionEnum {
    FRANCHISE = "FRANCHISE", 
    LOCATION_PARTNER = "LOCATION_PARTNER",
    NONE = "NONE"
}